import { jsx as _jsx } from "react/jsx-runtime";
import AdminTaskPageLayout from '../../../layout/AdminTaskPageLayout';
import { useParams } from 'react-router-dom';
const CreateTaskPage = () => {
    const { id } = useParams();
    return _jsx(AdminTaskPageLayout, { formType: 'create', rallyId: id });
};
export default CreateTaskPage;
